module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/8628ba88ec9dc2777d0e37646513fbb6.png";